// Utility to normalize card condition values from various platforms to standard codes
// Standard codes: M, NM, EX, GD, LP, PL, PO

const conditionMap = {
  // Cardmarket/TCGPlayer/Generic
  'm': 'M', 'mint': 'M',
  'nm': 'NM', 'near mint': 'NM',
  'ex': 'EX', 'excellent': 'EX', 'sp': 'EX', 'slightly played': 'EX',
  'gd': 'GD', 'good': 'GD',
  'lp': 'LP', 'light played': 'LP', 'mp': 'LP', 'moderately played': 'LP',
  'pl': 'PL', 'played': 'PL', 'hp': 'PL', 'heavily played': 'PL',
  'po': 'PO', 'poor': 'PO', 'dmg': 'PO', 'damaged': 'PO',
  // MoxField
  'near mint (nm)': 'NM', 'slightly played (sp)': 'EX', 'moderately played (mp)': 'LP', 'heavily played (hp)': 'PL', 'damaged (dmg)': 'PO',
  // ManaBox
  'mint (m)': 'M', 'good (gd)': 'GD',
};

export default function normalizeCondition(input) {
  if (!input) return '';
  const key = input.trim().toLowerCase();
  return conditionMap[key] ||
    // Try to match by partials
    (Object.keys(conditionMap).find(k => key === k || key.includes(k)) ? conditionMap[Object.keys(conditionMap).find(k => key === k || key.includes(k))] : input);
}
